<script>
  export let onClick = () => {}, icon = null, highlight = false;
</script>

<button
  class="Button"
  class:Main={highlight}
  data-icon-before="{icon}"
  on:click="{onClick}"
>
  <slot></slot>
</button>

<style lang="stylus">

  .Button {
    padding: 2px 5px;
    align-items: center;
    display: flex;
    font-size 12px;
    background white linear-gradient(0deg, #f5f6f7 10%, white 11.05%, white 100%);
    height 27px;

    &:before {
      margin 0 5px 0 0;
      font-size 18px;
    }

    &.Main{
      background #00b8ab linear-gradient(0deg, #00b0a3 10%, #00b8ab 11.05%, #00b8ab 100%)
      color: #fff;
      border: 1px solid #00b8a9;
    }
  }

</style>
